import * as Icons from '@mui/icons-material'
import dashboardDark from '../../assets/screenshots/dashboard-dark.png'
import dashboardLight from '../../assets/screenshots/dashboard-light.png'
import editCropDark from '../../assets/screenshots/edit-crop-dark.png'
import editCropLight from '../../assets/screenshots/edit-crop-light.png'
import afmDark from '../../assets/screenshots/afm-pg2-interp-dark.png'
import afmLight from '../../assets/screenshots/afm-pg2-interp-light.png'
import timelineDark from '../../assets/screenshots/timeline-dark.png'
import timelineLight from '../../assets/screenshots/timeline-light.png'
import successionDark from '../../assets/screenshots/succession-dark.png'
import successionLight from '../../assets/screenshots/succession-light.png'
import metricsDark from '../../assets/screenshots/metrics-dark.png'
import metricsLight from '../../assets/screenshots/metrics-light.png'
import harvestDark from '../../assets/screenshots/harvest-log-dark.png'
import harvestLight from '../../assets/screenshots/harvest-log-light.png'
import cropRelsDark from '../../assets/screenshots/crop-rels-dark.png'
import cropRelsLight from '../../assets/screenshots/crop-rels-light.png'
import apmDark from '../../assets/screenshots/apm-dark.png'
import apmLight from '../../assets/screenshots/apm-light.png'

export const FEATURES = [
  {
    icon: <Icons.GridViewTwoTone fontSize="large" />,
    title: 'Comprehensive Dashboard',
    body: 'A unified view combining an interactive timeline with a location-based list and map navigation — everything you need in one place.',
    screenshotDark: dashboardDark,
    screenshotLight: dashboardLight,
  },
  {
    icon: <Icons.YardTwoTone fontSize="large" />,
    title: 'Full Crop Visibility',
    body: 'Track any crop across your farm. See its full schedule, upcoming required tasks, and projected harvest windows at a glance.',
    screenshotDark: editCropDark,
    screenshotLight: editCropLight,
  },
  {
    icon: <Icons.PublicTwoTone fontSize="large" />,
    title: 'Farm Anywhere in the World',
    body: 'Create farms at any location on earth, backed by trusted agrometeorological data from the Copernicus Data Store (CDS).',
    screenshotDark: afmDark,
    screenshotLight: afmLight,
  },
  {
    icon: <Icons.TaskAltTwoTone fontSize="large" />,
    title: 'Dynamic Scheduling',
    body: 'Acknowledge completed tasks and watch your crop schedules automatically adapt — keeping your timeline accurate as the season unfolds.',
    screenshotDark: timelineDark,
    screenshotLight: timelineLight,
  },
  {
    icon: <Icons.AutorenewTwoTone fontSize="large" />,
    title: 'Succession Planting',
    body: 'Add successions to any crop using any growth type. Plan staggered harvests with ease and keep your plots productive all season.',
    screenshotDark: successionDark,
    screenshotLight: successionLight,
  },
  {
    icon: <Icons.InsightsTwoTone fontSize="large" />,
    title: 'Insights & Metrics',
    body: "Understand your farm's performance with yield statistics, plot area breakdowns, and growing degree day tracking.",
    screenshotDark: metricsDark,
    screenshotLight: metricsLight,
  },
  {
    icon: <Icons.ScaleTwoTone fontSize="large" />,
    title: 'Harvest Yield Tracking',
    body: 'Log harvests against any crop with a date and weight. Build a record of actual yields over time to inform future planning.',
    screenshotDark: harvestDark,
    screenshotLight: harvestLight,
  },
  {
    icon: <Icons.JoinInnerTwoTone fontSize="large" />,
    title: 'Companion Planting',
    body: 'Instantly surface intercrop relationships across your plots — strong companions, family inhibitions, and everything in between.',
    screenshotDark: cropRelsDark,
    screenshotLight: cropRelsLight,
  },
  {
    icon: <Icons.SatelliteAltTwoTone fontSize="large" />,
    title: 'Custom Plot Mapping',
    body: 'Draw your plots directly onto satellite imagery. Precise boundaries mean accurate area calculations and a true picture of your land.',
    screenshotDark: apmDark,
    screenshotLight: apmLight,
  },
]
